const staticMessage = {
    save:"Save information successfully!",
    update:"Update information successfully!",
    delete:"Delete information successfully!",
    modalConfirm:"modal-confirm"
}

export default staticMessage;